import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Jersey: Country = {
    identifier: "Jersey",
    name: "Jersey",
    countryCode: "JE",
    group: CountryGroup.EUROPE,
    isUNMember: false,
    flag: "🇯🇪",
    svgPath: "m 469.22975,304.5504 0.025,0.216 -0.123,0.047 -0.105,-0.075 -0.209,0 -0.197,0.047 0.043,-0.386 0.388,0.047 z",
}
